// Collapsible section accordion smooth and toggle script
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion details");

  if (accordions.length > 0) {
    accordions.forEach((accordion, index) => {
      const summary = accordion.querySelector("summary");
      const content = accordion.querySelector(".accordion__content");

      if (!summary || !content) return;

      // Initial setup
      content.style.overflow = "hidden";
      content.style.transition = "max-height 0.4s ease";

      if (index === 0) {
        // First accordion open by default
        accordion.setAttribute("open", "");
        content.style.maxHeight = content.scrollHeight + "px";
        setTimeout(() => {
          if (accordion.hasAttribute("open")) {
            content.style.maxHeight = "none";
          }
        }, 400);
      } else {
        accordion.removeAttribute("open");
        content.style.maxHeight = "0px";
      }

      summary.addEventListener("click", function (e) {
        e.preventDefault();

        if (accordion.hasAttribute("open")) {
          // CLOSE
          content.style.maxHeight = content.scrollHeight + "px";
          requestAnimationFrame(() => {
            content.style.maxHeight = "0px";
          });
          accordion.removeAttribute("open");
        } else {
          // CLOSE all others
          accordions.forEach((other) => {
            if (other !== accordion && other.hasAttribute("open")) {
              const otherContent = other.querySelector(".accordion__content");
              otherContent.style.maxHeight = otherContent.scrollHeight + "px";
              requestAnimationFrame(() => {
                otherContent.style.maxHeight = "0px";
              });
              other.removeAttribute("open");
            }
          });

          // OPEN current
          accordion.setAttribute("open", "");
          content.style.maxHeight = content.scrollHeight + "px";

          setTimeout(() => {
            if (accordion.hasAttribute("open")) {
              content.style.maxHeight = "none";
            }
          }, 400);
        }
      });
    });
  }
});
